// Reading integration-api answers: the `data` of a ResponseBase envelope, and the field errors of a
// 400 ValidationErrorResponse. Shared by the onboarding wizard and the SLA approvers page.
import axios from 'axios';

import type { ValidationErrorDto } from '@/gen/types/ValidationErrorDto';
import type { ValidationErrorResponse } from '@/gen/types/ValidationErrorResponse';

/** The envelope's payload; an envelope without one is a broken answer, not an empty result. */
export function requirePayload<T>(data: T | null | undefined, api: string, operation: string): T {
    if (data === null || data === undefined) {
        throw new Error(`${api} returned no payload for ${operation}.`);
    }
    return data;
}

/**
 * Field-level errors from a 400, or null when the failure is not a validation answer.
 * The integration API speaks ValidationErrorResponse ({ errors: [{ field, message }] }),
 * not the ValidationProblemDetails dictionary the incident API uses.
 */
export function getValidationErrors(error: unknown): ValidationErrorDto[] | null {
    if (!axios.isAxiosError(error) || error.response?.status !== 400) return null;
    const errors = (error.response.data as ValidationErrorResponse | undefined)?.errors;
    return Array.isArray(errors) && errors.length > 0 ? errors : null;
}
